angular.module('tgaAdmin').controller('HubRegistrationController', [
  '$scope',
  '$state',
  '$location',
  '$timeout',
  '$uibModal',
  'hubService',
  '$log',
  '$translate',
  function ($scope, $state, $location, $timeout, $uibModal, hubService, $log, $translate) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      alerts: [],
      hubId: $state.params.hub_id || null,
      registrationFields: {
        first_name: {
          key: 'first_name',
          label: 'First Name',
          condition: 'required',
          disabled: true,
        },
        last_name: {
          key: 'last_name',
          label: 'Last Name',
          condition: 'required',
          disabled: true,
        },
        email: {
          key: 'email',
          label: 'Email Address',
          condition: 'required',
          disabled: true,
        },
        /* phone: {
          key: 'phone',
          label: 'Phone Number',
          condition: null,
        },
        employee_id: {
          key: 'employee_id',
          label: 'ID',
          condition: null,
        },
        country: {
          key: 'country',
          label: 'Country',
          condition: null,
        },
        organization: {
          key: 'organization',
          label: 'Organization',
          condition: null,
        }, */
      },
      registrationFieldOptions: [
        {
          id: 'required',
          name: 'Required',
        },
        {
          id: 'optional',
          name: 'Optional',
        },
        {
          id: null,
          name: 'Disabled',
        },
      ],
      registrationFieldArray: [],
    };

    $scope.viewmodel = {
      hub_id: $scope.data.hubId,
      players: [],
      user: {},
      registration: {
        required: null,
        fields: [],
      },
    };

    $scope.initialize = function () {
      $scope.loading = true;

      hubService
        .getHub($scope.data.hubId)
        .then((hub) => {
          $scope.viewmodel.hub = hub;
          if ($scope.actions.invitationSettingsIncomplete()) {
            $scope.activeTab = 1;
          }
          $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Registration`;

          // Roll data.registrationFields initial state into viewmodel.registration.fields
          $scope.viewmodel.registration.fields = angular.extend(
            {},
            $scope.data.registrationFields,
            _.keyBy(hub.registration.fields, 'key'),
          );

          hubService
            .getRegistration()
            .then((players) => {
              $scope.viewmodel.players = players;
              $scope.loading = false;
            })
            .catch((error) => {
              $log.log(error);
            });
        })
        .catch((error) => {
          $log.log(error);
        });
    };

    $scope.actions = {
      playerStatus(player, status) {
        player.status = status;
        hubService.updatePlayer(player).then(
          () => {},
          (error) => {
            $log.log(error);
            player.status = !status;
          },
        );
      },
      invitationSettingsIncomplete() {
        return (
          !$scope.viewmodel.hub
          || !$scope.viewmodel.hub.from_name
          || !$scope.viewmodel.hub.from_email
          || !$scope.viewmodel.hub.from_company
        );
      },
      // eslint-disable-next-line consistent-return
      uploadList() {
        if ($scope.actions.invitationSettingsIncomplete()) {
          return $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Please update your Invitation Settings.',
            'danger',
          );
        }
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-hub-registration-upload.html',
            controller: 'HubRegistrationUploadModalController',
            backdrop: true,
          })
          .result.then(() => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Players added successfully.', 'success');
            $scope.initialize();
          })
          .catch(angular.noop);
      },
      // eslint-disable-next-line consistent-return
      submit(form) {
        if ($scope.actions.invitationSettingsIncomplete()) {
          return $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Please update your Invitation Settings.',
            'danger',
          );
        }

        form.submitted = true;

        $scope.actions.clearAlerts();

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          // eslint-disable-next-line consistent-return
          return;
        }

        $scope.processing = true;

        hubService
          .addRegistration($scope.viewmodel.user)
          .then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade updated.', 'success');
              $scope.viewmodel.user = {};
              $scope.initialize();
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            },
          )
          .finally(() => {
            $scope.processing = false;
            form.submitted = false;
          });
      },
      sendInvitation(user) {
        $scope.actions.clearAlerts();

        user.sending = true;

        hubService.sendInvitation(user.user_id).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Invitation sent.', 'success');
            user.sending = false;
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            user.sending = false;
          },
        );
      },
      updateSettings(form) {
        form.submitted = true;

        $scope.actions.clearAlerts();

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        hubService
          .updateRegistrationSettings($scope.viewmodel.hub)
          .then(() => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Invitation settings updated.', 'success');
            $scope.initialize();
            $scope.processing = false;
          })
          .catch((error) => {
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${error.message}`, 'danger');
            $scope.processing = false;
          });
      },
      updateFields() {
        $scope.actions.clearAlerts();
        $scope.processing = true;

        hubService
          .updateRegistrationFields($scope.viewmodel.registration)
          .then(() => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Registration fields updated.', 'success');
            $scope.initialize();
            $scope.processing = false;
          })
          .catch((error) => {
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${error.message}`, 'danger');
            $scope.processing = false;
          });
      },
      checkLeaderboardFields() {
        $scope.viewmodel.custom_fields.forEach((field) => {
          if (field.show_in_leaderboard) {
            $scope.data.registrationFieldArray.push(field.custom_field_id);
          }
        });
      },
      changeCustomFieldCondition(field) {
        if (angular.isUndefined(field.condition)) {
          if ($scope.data.registrationFieldArray.indexOf(field.custom_field_id) > -1) {
            field.show_in_leaderboard = false;
            $scope.data.registrationFieldArray.splice(
              $scope.data.registrationFieldArray.indexOf(field.custom_field_id),
              1,
            );
          }
        }
      },
      addCustomRegistrationField() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-custom-field.html',
            controller: 'CustomFieldModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  hub_id: $scope.data.hubId,
                };
              },
            },
          })
          .result.then((custom_field) => {
            custom_field.condition = 'required';
            $scope.viewmodel.custom_fields.push(custom_field);
          })
          .catch(angular.noop);
      },
      createAlert(msg, type) {
        $scope.actions.clearAlerts();
        $scope.data.alerts.push({
          msg,
          type,
        });

        $scope.timer = $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, 5000);
      },
      clearAlerts() {
        $scope.data.alerts = [];
        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }
      },
    };

    $scope.initialize();
  },
]);
